import { ContainerType } from '@/models/common'

interface DocumentIdConfig {
  sourcePrefix: string
  jsonPath: string
}

const DOCUMENT_ID_CONFIGS: Record<ContainerType, DocumentIdConfig> = {
  [ContainerType.TABLE]: {
    sourcePrefix: '$.document',
    jsonPath: '$..documentId'
  },
  [ContainerType.REPORT]: {
    sourcePrefix: '$.data.documents',
    jsonPath: '$..ref_no'
  },
  [ContainerType.LIST]: {
    sourcePrefix: '',
    jsonPath: ''
  },
  [ContainerType.COMPOSITE]: {
    sourcePrefix: '',
    jsonPath: ''
  },
  [ContainerType.CHART]: {
    sourcePrefix: '',
    jsonPath: ''
  }
}

class ContainerService {
  canShowDocumentId (
    containerType: ContainerType,
    containerSource?: string,
    editUrl?: string
  ): boolean {
    const config = DOCUMENT_ID_CONFIGS[containerType]

    if (!config || !config.sourcePrefix) {
      return false
    }

    return (
      containerSource?.startsWith(config.sourcePrefix) === true &&
      editUrl !== undefined &&
      editUrl.trim() !== ''
    )
  }

  getDocumentId (
    containerType: ContainerType,
    containerSource?: string,
    editUrl?: string,
    data?: any,
    getCellValue?: (source: any, accessKey: string) => any
  ): any {
    const config = DOCUMENT_ID_CONFIGS[containerType]
    if (!getCellValue || !config.jsonPath) {
      return null
    }

    if (!this.canShowDocumentId(containerType, containerSource, editUrl)) {
      return null
    }

    return {
      'document-id': getCellValue(data, config.jsonPath)
    }
  }
}

export default new ContainerService()
